const version = "1.0.3.0";

export default version;
